var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrossGreyIcon = function SvgCrossGreyIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9619 3.2209L14.0253 2.16299L11.9095 0.0361938L10.8461 1.09411L7.03628 4.88428L3.22647 1.09411L2.16307 0.0361938L0.0472412 2.16299L1.11064 3.2209L4.90945 7.00014L1.11064 10.7794L0.0472412 11.8373L2.16307 13.9641L3.22647 12.9062L7.03628 9.116L10.8461 12.9062L11.9095 13.9641L14.0253 11.8373L12.9619 10.7794L9.1631 7.00014L12.9619 3.2209Z",
    fill: "#979797"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrossGreyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cross_grey_icon.74ee1a04e1d84f52c60962cc1db33d7f.svg";